import React from 'react';
import ProjectOversightLayout from './projectOversight/ProjectOversightLayout';

const ProjectChats = () => <ProjectOversightLayout mode="chat" />;

export default ProjectChats;
